import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const LOGO = "https://customer-assets.emergentagent.com/job_site-forge-1397/artifacts/d1s6931k_IMG_20240729_213037_088.jpg";

const NAV = [
  { label: "Cover Story", href: "#cover" },
  { label: "Sections", href: "#sections" },
  { label: "Features", href: "#features" },
  { label: "Themes", href: "#themes" },
  { label: "Partners", href: "#partners" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-header"
      className={`sticky top-0 z-50 backdrop-blur-xl bg-[#F4F4F0]/85 transition-all ${
        scrolled ? "border-b border-[#2E1A6B]/15" : "border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between gap-6">
        <a href="#top" data-testid="header-logo" className="flex items-center gap-2">
          <img src={LOGO} alt="Listen Magazine" className="h-8 md:h-10 w-auto object-contain" />
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV.map((n) => (
            <a
              key={n.href}
              href={n.href}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-xs uppercase tracking-[0.2em] font-semibold text-[#1A1A1A] link-underline"
            >
              {n.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href="#partners"
            data-testid="header-advertise-btn"
            className="text-xs uppercase tracking-[0.2em] font-semibold px-4 py-2.5 border border-[#2E1A6B] text-[#2E1A6B] hover:bg-[#2E1A6B] hover:text-white transition-colors"
          >
            Advertise
          </a>
          <a
            href="#subscribe"
            data-testid="header-subscribe-btn"
            className="text-xs uppercase tracking-[0.2em] font-semibold px-4 py-2.5 bg-[#2E1A6B] text-white hover:bg-[#2AC1E0] hover:text-[#2E1A6B] transition-colors"
          >
            Subscribe
          </a>
        </div>

        <button
          data-testid="mobile-menu-toggle"
          className="md:hidden p-2 text-[#2E1A6B]"
          onClick={() => setOpen((v) => !v)}
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="md:hidden border-t border-[#2E1A6B]/15 bg-[#F4F4F0]">
          <div className="px-5 py-6 flex flex-col gap-4">
            {NAV.map((n) => (
              <a
                key={n.href}
                href={n.href}
                data-testid={`mobile-nav-${n.label.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setOpen(false)}
                className="text-sm uppercase tracking-[0.2em] font-semibold text-[#1A1A1A]"
              >
                {n.label}
              </a>
            ))}
            <div className="flex gap-3 pt-3">
              <a
                href="#partners"
                onClick={() => setOpen(false)}
                data-testid="mobile-advertise-btn"
                className="flex-1 text-center text-xs uppercase tracking-[0.2em] font-semibold px-4 py-3 border border-[#2E1A6B] text-[#2E1A6B]"
              >
                Advertise
              </a>
              <a
                href="#subscribe"
                onClick={() => setOpen(false)}
                data-testid="mobile-subscribe-btn"
                className="flex-1 text-center text-xs uppercase tracking-[0.2em] font-semibold px-4 py-3 bg-[#2E1A6B] text-white"
              >
                Subscribe
              </a>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
